import { PAYOUT_REQUEST_MINIMUM_USD } from "@newform/constants";

/**
 * A request's guarantee, for display. The frontend can deploy ahead of the
 * backend, and a backend from before per-request guarantees sends no figure
 * for a few minutes; every request it serves pays the $100 floor, so that is
 * what to show rather than throwing on a missing number.
 */
export function requestGuaranteeUsd(request: {
  guaranteeUsd?: number | null;
}): number {
  const value = request.guaranteeUsd;
  return typeof value === "number" && Number.isFinite(value)
    ? value
    : PAYOUT_REQUEST_MINIMUM_USD;
}
